// Zod schemas shared between api (input validation) and web (form validation).
// One source of truth for the shape of API requests/responses.

import { z } from "zod";

export const centsSchema = z
  .number()
  .int("Cents must be an integer")
  .nonnegative("Cents must be non-negative");

export const lineNoteSchema = z.string().trim().max(500).nullable().optional();

export const saleItemInputSchema = z.object({
  productId: z.number().int().positive(),
  unitPriceCents: centsSchema,
  qty: z.number().int().positive(),
  lineDiscountCents: centsSchema.default(0),
  sizeGuideId: z.number().int().positive().nullable().optional(),
  size: z.string().trim().min(1).max(20).nullable().optional(),
  note: lineNoteSchema,
});

export const createSaleSchema = z.object({
  clientId: z.string().uuid(),
  paymentMethodId: z.number().int().positive(),
  globalDiscountCents: centsSchema.default(0),
  customerId: z.number().int().positive().nullable().optional(),
  netReceivedOverride: centsSchema.optional(),
  note: z.string().max(500).optional(),
  items: z.array(saleItemInputSchema).min(1, "At least one item required"),
});

export type CreateSaleInput = z.infer<typeof createSaleSchema>;
